import { saveIndexQuery } from '@/services/analytics/Action';
import { useDispatch, useSelector } from 'react-redux';

export const useSingleIndexQuery = () => {
  const dispatch = useDispatch();
  const indexQuery = useSelector((state) => state.analytics.indexQuery);

  const setQuery = (obj) => {
    dispatch(
      saveIndexQuery({
        ...indexQuery,
        index: {
          ...indexQuery.index,
          singleIndex: {
            ...indexQuery.index.singleIndex,
            ...obj,
          },
        },
      }),
    );
  };

  return [setQuery];
};
